<template>
  <div class="rangeGridComponent noselect">
    <div class="rangeGridInstance main">
      <div v-for="(row, i) in rows" class="rangeGridRow" :key="i">
        <div
          v-for="squareData in row"
          :key="squareData.squareString"
          class="rangeGridCell"
          :class="{
            marked: squareData.isMarked,
            unmarked: hasMarkedSquares && !squareData.isMarked,
          }"
        >
          <RangeGridSquare
            :squareString="squareData.squareString"
            :comboStrings="squareData.comboStrings"
            :filteredComboStrings="squareData.filteredComboStrings"
            :subrangeByComboString="squareData.subrangeByComboString"
            :colorScheme="colorScheme"
            :preferSuits="boardSuits"
            @startPaint="startPaint"
            @continuePaint="paint"
            @mouseover="$emit('mouseoverSquare', squareData.squareString)"
            @mouseout="$emit('mouseoutSquare', squareData.squareString)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chunk from "lodash/chunk";
import { CARD_VALUES } from "../constants";
import RangeGridSquare from "./RangeGridSquare";
import { allSquareStrings, squareStringToComboStrings } from "../helpers/cards";

export default {
  name: "RangeGrid",
  components: { RangeGridSquare },
  props: {
    subrangeByComboString: { type: Object, required: true },
    boardSuits: { type: Array, default: () => [] },
    boardFilteredComboStrings: { type: Array, required: true },
    colorScheme: { type: Array, required: true },
    markedSquareStrings: { type: Array, default: () => [] },
  },
  data() {
    return {};
  },
  computed: {
    rows() {
      const squareStringData = allSquareStrings.map(squareString => {
        const comboStrings = squareStringToComboStrings(squareString);
        return {
          squareString,
          comboStrings,
          filteredComboStrings: comboStrings.filter(comboString =>
            this.boardFilteredComboStrings.includes(comboString)
          ),
          subrangeByComboString: this.subrangeByComboString,
          isMarked: this.markedSquareStrings.includes(squareString),
        };
      });
      return chunk(squareStringData, CARD_VALUES.length);
    },
    hasMarkedSquares() {
      return this.markedSquareStrings.length > 0;
    },
  },
  methods: {
    startPaint(squareString) {
      this.$emit("toggleSquare", squareString, true);
    },
    paint(squareString) {
      this.$emit("toggleSquare", squareString);
    },
  },
};
</script>

<style lang="scss" scoped>
.rangeGridComponent {
  width: 500px;
  height: 500px;
  position: relative;
}

.rangeGridInstance {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid black;
}

.rangeGridRow {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

.rangeGridCell {
  flex: 1;
  position: relative;
  top: 0;
  left: 0;
  box-shadow: none;
  transition: top, left, box-shadow, filter;
  transition-duration: 0.1s;
  &.marked {
    top: -3px;
    left: -3px;
    box-shadow: 3px 3px 3px 1px rgba(0, 0, 0, 1);
  }
  &.unmarked {
    filter: blur(2px) contrast(90%) grayscale(60%);
  }
}
</style>
